import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Scene({ image, kicker, title, body, align = "left", testid }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-9%", "9%"]);

  const centered = align === "center";

  return (
    <section
      ref={ref}
      data-testid={testid}
      className={`relative ${centered ? "h-screen" : "h-[88vh]"} overflow-hidden flex items-center`}
    >
      <motion.div style={{ y, scale: 1.18 }} className="absolute inset-0 will-change-transform">
        <img src={image} alt={title} className="w-full h-full object-cover" />
      </motion.div>
      <div
        className="absolute inset-0"
        style={{
          background: centered
            ? "linear-gradient(to bottom, rgba(5,7,10,0.55), rgba(5,7,10,0.45) 50%, rgba(5,7,10,0.8))"
            : "linear-gradient(to right, rgba(5,7,10,0.85), rgba(5,7,10,0.35) 55%, rgba(5,7,10,0.15))," +
              "linear-gradient(to top, rgba(5,7,10,0.85), transparent 40%)",
        }}
      />

      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className={centered ? "text-center mx-auto max-w-3xl" : "max-w-2xl"}
        >
          <div className={`flex items-center gap-3 mb-6 ${centered ? "justify-center" : ""}`}>
            <span className="w-9 h-[1px] bg-crystal" />
            <span className="font-mono text-[11px] tracking-[0.35em] uppercase text-crystal">{kicker}</span>
          </div>
          <h2
            className="font-display font-medium text-white leading-[1.0] tracking-tight text-[clamp(2.4rem,5.5vw,4.6rem)]"
            style={{ textShadow: "0 8px 40px rgba(0,0,0,0.55)" }}
            data-testid={`${testid}-title`}
          >
            {title}
          </h2>
          {body && (
            <p className={`mt-6 text-mist leading-relaxed text-base sm:text-lg ${centered ? "mx-auto" : ""}`}>
              {body}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
